import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SessionService } from '../../services/session.service';

/**
 * Tab menu for the admin dashboard pages. Mirrors app-admin-nav's look, but
 * scopes the tabs to the dashboard's own sections.
 */
@Component({
    selector: 'app-dashboard-nav',
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './dashboard-nav.component.html',
    styleUrl: './dashboard-nav.component.scss',
})
export class DashboardNavComponent {
    constructor(public session: SessionService) { }
}
